import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="bg-cream py-20 px-4 md:px-8 lg:px-16 text-navy" data-id="element-11">
      <div className="max-w-6xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-terracotta mb-4 uppercase tracking-wider" data-id="element-14">
            OFERTA ESPECIAL: BONUS TÁCTICOS DE EMERGENCIA
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-700 font-medium" data-id="element-15">
            GRATIS HOY con tu Pack Reconexión Familiar Total:
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-16">
          {/* Bonus 1 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 border border-gray-200 shadow-md relative overflow-hidden" data-id="element-17">
            <div className="absolute top-4 right-4 bg-terracotta text-white font-bold py-1 px-3 rounded-full text-sm shadow-lg z-10" data-id="element-18">
              ¡GRATIS HOY!
            </div>
            <div className="mb-6 flex justify-center" data-id="element-19">
              <img src="https://cdn.magicpatterns.com/uploads/w9Tr12MGvGMsKvdxMXp8L8/Senales_de_Alerta_Como_distinguir_la_rebeldia_tipica_de_una_cuadro_de_ansiedad_o_depresion_UNA_GUIA_PARA_IDENTIFICAR_BANDERAS_ROJAS_DE_SALUD_MENTAL.png" alt="Libro ¿Rebeldía o Ansiedad?" className="h-64 object-contain drop-shadow-xl" data-id="element-20" />
            </div>
            <h3 className="text-2xl font-bold text-terracotta mb-2" data-id="element-21">
              OFERTA ESPECIAL #1
            </h3>
            <h4 className="text-xl font-serif font-bold text-navy mb-4" data-id="element-22">
              Libro "¿Rebeldía o Ansiedad? (Señales de Alerta)"
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-23">
              ¿Es solo rebeldía típica de la edad o hay un cuadro clínico de
              fondo? Este manual de alertas te enseña a distinguir los síntomas
              clave para saber cuándo tu hijo necesita ayuda profesional y cómo
              dársela sin que se sienta juzgado. No pierdas tiempo valioso.
            </p>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div variants={itemVariants} className="bg-white rounded-2xl p-8 border border-gray-200 shadow-md relative overflow-hidden" data-id="element-24">
            <div className="absolute top-4 right-4 bg-terracotta text-white font-bold py-1 px-3 rounded-full text-sm shadow-lg z-10" data-id="element-25">
              ¡GRATIS HOY!
            </div>
            <div className="mb-6 flex justify-center" data-id="element-26">
              <img src="https://cdn.magicpatterns.com/uploads/aZEpZTSfThkANxA22o6tS5/4.png" alt="Libro La Noche y la Calle" className="h-64 object-contain drop-shadow-xl" data-id="element-27" />
            </div>
            <h3 className="text-2xl font-bold text-terracotta mb-2" data-id="element-28">
              OFERTA ESPECIAL #2
            </h3>
            <h4 className="text-xl font-serif font-bold text-navy mb-4" data-id="element-29">
              Libro "La Noche y la Calle" (Kit de Negociación)
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-30">
              El manual definitivo para negociar salidas, horarios y peligros
              sin vivir con el corazón en la boca. Establecé reglas claras que
              él respete, manteniendo la calma y el mando sin terminar a los
              gritos.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}